<template>
    <div class="welcome-container">
      <el-card class="welcome-card">
        <template #header>
          <div class="card-header">
            <h2>欢迎回来，{{ username }}</h2>
            <el-button @click="logout" type="text">退出登录</el-button>
          </div>
        </template>
        <div class="welcome-content">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="8" class="stat-col">
              <el-card class="box-card">
                <template #header>
                  <div class="box-card-header">
                    <span>授权统计</span>
                    <el-button class="button" type="text">查看详情</el-button>
                  </div>
                </template>
                <div class="item">
                  <span>有效授权：</span>
                  <span>{{ stats.validAuth }}</span>
                </div>
                <div class="item">
                  <span>即将过期：</span>
                  <span>{{ stats.expiringAuth }}</span>
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="8" class="stat-col">
              <el-card class="box-card">
                <template #header>
                  <div class="box-card-header">
                    <span>快速操作</span>
                  </div>
                </template>
                <div class="quick-actions">
                  <el-button @click="navigateTo('/auth-management')" :size="isMobile ? 'large' : ''">授权管理</el-button>
                  <el-button @click="navigateTo('/interested-users')" :size="isMobile ? 'large' : ''">意向用户管理</el-button>
                  <el-button @click="navigateTo('/user-login-info')" :size="isMobile ? 'large' : ''">用户登录信息</el-button>
                  <el-button @click="navigateTo('/bug-management')" :size="isMobile ? 'large' : ''">Bug管理</el-button>
                  <!-- <el-button @click="navigateTo('/reports')" :size="isMobile ? 'large' : ''">报表中心</el-button> -->
                </div>
              </el-card>
            </el-col>
            <el-col :xs="24" :sm="8" class="stat-col">
              <el-card class="box-card">
                <template #header>
                  <div class="box-card-header">
                    <span>系统公告</span>
                  </div>
                </template>
                <ul class="announcement-list">
                  <li v-for="(announcement, index) in announcements" :key="index">
                    {{ announcement }}
                  </li>
                </ul>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </el-card>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted } from 'vue'
  import { useRouter } from 'vue-router'
  import { ElMessage } from 'element-plus'
  import { useWindowSize } from '@vueuse/core'
  import authApi from '../js/connect.js'
  
  const { width } = useWindowSize()
  const isMobile = computed(() => width.value <= 768)
  
  const router = useRouter()
  const username = ref('管理员') // 这里应该从登录状态或 store 中获取
  
  onMounted(() => {
    // 从本地存储获取用户名
    const userInfo = localStorage.getItem('user_info');
    if (userInfo) {
      try {
        const parsedInfo = JSON.parse(userInfo);
        username.value = parsedInfo.username || '管理员';
      } catch (e) {
        console.error('解析用户信息失败:', e);
      }
    }
  })
  
  const stats = ref({
    validAuth: 150,
    expiringAuth: 5
  })
  
  const announcements = ref([
    '系统将于本周日进行例行维护，请提前做好准备。',
    '新版本功能已上线，欢迎体验并提供反馈。',
    '请及时处理即将过期的授权。'
  ])
  
  const navigateTo = (path) => {
    router.push(path)
  }
  
  const logout = () => {
    // 使用authApi的logout方法清除登录状态
    authApi.logout();
    
    // 显示成功消息
    ElMessage.success('已成功退出登录')
    
    // 跳转到登录页面
    router.push('/login')
  }
  </script>
  
  <style scoped>
  .welcome-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 100vh;
  background-color: var(--dca-bg);
  padding: 32px 20px;
}

.welcome-card {
  width: 100%;
  max-width: 1200px;
}

.card-header h2 {
  margin: 0;
  font-size: 20px;
  color: var(--dca-text);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.welcome-content {
  margin-top: 20px;
}

.box-card {
  margin-bottom: 20px;
  height: 100%;
  background-color: var(--dca-bg-2);
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.box-card:hover {
  transform: translateY(-4px);
  border-color: var(--dca-border-strong);
}

.box-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--dca-text);
}

.item {
  margin-bottom: 10px;
  font-size: 14px;
  color: var(--dca-text-muted);
}

.quick-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.quick-actions :deep(.el-button) {
  margin-left: 0;
  background-color: var(--dca-surface-2);
  border-color: var(--dca-border);
  color: var(--dca-text);
}

.quick-actions :deep(.el-button:hover) {
  border-color: var(--dca-accent);
  color: var(--dca-accent);
  background-color: var(--dca-accent-soft);
}

.announcement-list {
  padding-left: 20px;
  margin: 0;
}

.announcement-list li {
  margin-bottom: 10px;
  font-size: 14px;
  color: var(--dca-text-muted);
}

/* 移动端样式适配 */
@media screen and (max-width: 768px) {
  .welcome-container {
    padding: 10px;
  }

  .welcome-card {
    width: 100%;
  }

  .card-header h2 {
    font-size: 18px;
  }

  .stat-col {
    margin-bottom: 15px;
  }

  .box-card {
    margin-bottom: 15px;
  }

  .box-card-header {
    font-size: 16px;
  }

  .quick-actions .el-button {
    width: 100%;
    margin-bottom: 10px;
  }

  .item, .announcement-list li {
    font-size: 13px;
  }
}
  </style>